import React from "react";

import { css } from "@emotion/core";
import { partial } from "lodash";

import { FormLabel, Radio } from "@zapier/design-system";

const optionsContainerCss = css`
  border: none;
  display: grid;
  grid-auto-flow: column;
  grid-gap: 20px;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
`;
type RadioOption = {
  key: string;
  displayText: string;
};
type Props = {
  id?: string;
  legend?: string;
  onSelectOption: (option: string) => void;
  options: RadioOption[];
  selectedOption: string;
};

const RadioButtonGroup: React.FC<Props> = ({
  id,
  onSelectOption,
  options = [],
  selectedOption,
}) => {
  const isSelected = (option: RadioOption["key"]) => selectedOption === option;

  return (
    <fieldset css={optionsContainerCss} id={id}>
      {options.map(option => (
        <FormLabel key={option.key}>
          <Radio
            checked={isSelected(option.key)}
            onChange={partial(onSelectOption, option.key)}
            value={option.key}
          />
          {option.displayText}
        </FormLabel>
      ))}
    </fieldset>
  );
};

export default RadioButtonGroup;
